export class Alert {
    id = 0;
    mode = 'message';
    message = '';
    title = '';
}